import { render, staticRenderFns } from "./SolicitudBajaCliente.vue?vue&type=template&id=3f7fbc1e&"
import script from "./SolicitudBajaCliente.vue?vue&type=script&lang=ts&"
export * from "./SolicitudBajaCliente.vue?vue&type=script&lang=ts&"
import style0 from "./SolicitudBajaCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3f7fbc1e', component.options)
    } else {
      api.reload('3f7fbc1e', component.options)
    }
    module.hot.accept("./SolicitudBajaCliente.vue?vue&type=template&id=3f7fbc1e&", function () {
      api.rerender('3f7fbc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaCliente/SolicitudBajaCliente.vue"
export default component.exports